export default "__VITE_ASSET__BZrySgSx__"